

import __layout_0 from '/home/rtldev/service/frontend-emoney/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/home/rtldev/service/frontend-emoney/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithHorizontalNav': () => import('/home/rtldev/service/frontend-emoney/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/home/rtldev/service/frontend-emoney/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/home/rtldev/service/frontend-emoney/src/layouts/components/Footer.vue'),
'components/NavBarNotifications': () => import('/home/rtldev/service/frontend-emoney/src/layouts/components/NavBarNotifications.vue'),
'components/NavSearchBar': () => import('/home/rtldev/service/frontend-emoney/src/layouts/components/NavSearchBar.vue'),
'components/NavbarShortcuts': () => import('/home/rtldev/service/frontend-emoney/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/home/rtldev/service/frontend-emoney/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/home/rtldev/service/frontend-emoney/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
